import { render, staticRenderFns } from "./AdvSelect.vue?vue&type=template&id=045521c5&scoped=true"
import script from "./AdvSelect.vue?vue&type=script&lang=js"
export * from "./AdvSelect.vue?vue&type=script&lang=js"
import style0 from "./AdvSelect.vue?vue&type=style&index=0&id=045521c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045521c5",
  null
  
)

export default component.exports